module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-list py-3"
  }, [_c('div', {
    staticClass: "row pt-1 description-area"
  }, [_c('p', {
    staticClass: "col-12 mb-1",
    staticStyle: {
      "text-align": "left",
      "padding": "0 2.5rem"
    }
  }, [_c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][2]",
      "isHtml": true
    }
  })], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "col-12 list-disc-styled",
    staticStyle: {
      "padding": "0px 3rem"
    }
  }, [_c('li', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][3]"
    }
  })], 1), _vm._v(" "), _c('li', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][4]"
    }
  })], 1), _vm._v(" "), _c('li', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][5]"
    }
  })], 1), _vm._v(" "), _c('li', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][6]"
    }
  })], 1), _vm._v(" "), _c('li', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][7]"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "col-12 mb-1",
    staticStyle: {
      "text-align": "left",
      "padding": "0 2.5rem"
    }
  }, [_c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][8]",
      "isHtml": true
    }
  })], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "col-12 list-disc-styled",
    staticStyle: {
      "padding": "0px 3rem"
    }
  }, [_c('li', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][9]"
    }
  })], 1), _vm._v(" "), _c('li', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][10]"
    }
  })], 1), _vm._v(" "), _c('li', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][11]"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "col-12 mb-1",
    staticStyle: {
      "text-align": "left",
      "padding": "0 2.5rem"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    staticStyle: {
      "font-size": "0.8em"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][12]",
      "isHtml": true
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "col-12 mb-1",
    staticStyle: {
      "text-align": "left",
      "padding": "0 2.5rem"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[92][13]",
      "isHtml": true
    }
  })], 1), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-12 mb-5",
    staticStyle: {
      "text-align": "left",
      "padding": "0 2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.google.co.jp/chrome/browser/desktop/"
    }
  }, [_vm._v("https://www.google.co.jp/chrome/browser/desktop/")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4df06ef2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/Unsupported/PageForm.vue
// module id = 701
// module chunks = 0